// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Let their way be dark and slippery,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;with the angel of the Lord pursuing them.<br> </p> </div></div>";
// Exports
module.exports = code;